import { useEffect, useState } from 'react';
/* helpers */
import { seasonCountFunction, seasonsSort } from '../../utils/seasonUtils.js'

export const useDidMount = (content,isLoading,countItem, currentSeason) => {
    const [result, setResult] = useState([]);
    const [seasonIndex, setSeasonIndex] = useState(1);
    const [seasonCount, setSeasonCount] = useState({});

    useEffect(() => {
        if (isLoading) {
            setResult([...new Array(countItem)]);
        } else {
            const contentCopy = {...content}; // copia del content
            const contentResult = contentCopy?.result;
            setResult(contentResult);
            setSeasonCount(seasonCountFunction(contentResult)) // Seteo de la cantidad de temporadas
            
            if(currentSeason !== 0) {
                setSeasonIndex(currentSeason)
            }
            else {
                setSeasonIndex(seasonsSort(seasonCount, contentResult)) // Seteo de la primera temporada que aparezca
            }
             
        }
    }, [content,isLoading])

    return {
        result,
        seasonCount,
        seasonIndex,
        setSeasonIndex
    }
}